import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from '@barfacil/barfacil-ui'
import { zodResolver } from '@hookform/resolvers/zod'
import { Plus } from 'lucide-react'
import { useState } from 'react'
import { useForm } from 'react-hook-form'

import { usePriceListContext } from '@/app/panel/management/price-list/_contexts/price-list-context'
import { useCreatePriceList } from '@/app/panel/management/price-list/_hooks/use-create-price-list'
import {
  FormCreatePriceList,
  FormCreatePriceListSchema,
} from '@/app/panel/management/price-list/_schemas/create-price-list'
import { useFormErrorHandler } from '@/hooks/use-form-error-handler'

export const CreatePriceListDialog = () => {
  const [open, setOpen] = useState(false)

  const { formErrors, mutation } = useCreatePriceList()
  const { priceListInfinite } = usePriceListContext()

  const form = useForm<FormCreatePriceList>({
    resolver: zodResolver(FormCreatePriceListSchema),
    defaultValues: {
      nome: '',
    },
  })

  useFormErrorHandler({
    form,
    formErrors,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
  })

  function handleOnClose() {
    setOpen(false)
  }

  function handleOnOpenChange(open: boolean) {
    form.reset()
    setOpen(open)
  }

  function handleSubmit<T>(e: React.FormEvent<T>) {
    e.preventDefault()

    return form.handleSubmit((data) =>
      mutation.mutate(data, { onSuccess: handleOnClose }),
    )()
  }

  return (
    <Dialog open={open} onOpenChange={handleOnOpenChange}>
      <DialogTrigger asChild>
        <Button
          className="max-w-min gap-2"
          variant="secondary"
          isCustom
          disabled={priceListInfinite.isFetching}
        >
          <Plus size={16} />
          NOVA LISTA
        </Button>
      </DialogTrigger>

      <DialogContent className="w-full max-w-md gap-8 overflow-visible">
        <DialogHeader>
          <DialogTitle className="leading-normal">
            NOVA LISTA DE PREÇO
          </DialogTitle>
        </DialogHeader>

        <DialogDescription className="hidden" />

        <DialogBody>
          <Form {...form}>
            <form
              onSubmit={handleSubmit}
              className="grid flex-1 grid-cols-1 gap-4"
            >
              <FormField
                control={form.control}
                name="nome"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Descrição</FormLabel>

                    <FormControl>
                      <Input
                        autoFocus
                        placeholder="Nome da lista de preço"
                        {...field}
                      />
                    </FormControl>

                    <FormMessage />
                  </FormItem>
                )}
              />

              <footer className="mt-4 flex flex-col-reverse items-center gap-2 sm:ml-auto sm:flex-row">
                <Button
                  type="button"
                  className="max-sm:w-full"
                  variant="tertiary"
                  disabled={mutation.isPending}
                  onClick={handleOnClose}
                >
                  CANCELAR
                </Button>

                <Button
                  className="w-full sm:w-[7.25rem]"
                  type="submit"
                  variant="primary"
                  isLoading={mutation.isPending}
                  disabled={mutation.isPending}
                >
                  CONFIRMAR
                </Button>
              </footer>
            </form>
          </Form>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
